
import { z } from "zod";
import { ContactRole } from "@/lib/types";

export const contactFormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  role: z.string().min(1, "Role is required"),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
